const styles = {
  button: {
    borderRadius: 1,
  },
  secondary: {
    backgroundColor: "#f0f2ee",
  },
};
export default styles;
